import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateVehicleTemplateEntity } from '../../domain/entities/CreateUpdateVehicleTemplateEntity'

export class CreateUpdateVehicleTemplateModel extends CreateUpdateVehicleTemplateEntity {
  constructor(dataDto: CreateUpdateVehicleTemplateEntity) {
    super()
    mapEntityProperties<CreateUpdateVehicleTemplateModel>(this, dataDto)
  }
}
